export default "__VITE_ASSET__Cs939Cce__"